import { SelectionChangedEvent } from "ag-grid-community";
import { TariffNatureEntity } from "domain/entity/TariffNature/TariffNatureEntity";
import { INITIAL_TARIFF_NATURE_COL_DEF } from "presentation/constant/TariffNature/TariffNatureMaintenanceColumnDefinition";
import { TariffNatureMaintenanceConstant } from "presentation/constant/TariffNature/TariffNatureMaintenanceConstant";
import { useTariffNatureMaintenanceVM } from "presentation/hook/TariffNature/useTariffNatureMaintenanceVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTariffNatureMaintenanceTracked } from "presentation/store/TariffNature/TariffNatureMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";


const TariffNatureTablePanel: React.FC = () => {
    const [tariffNatureState] = useTariffNatureMaintenanceTracked();
    const tariffNatureVM = useTariffNatureMaintenanceVM();
    const gridRef: any = useRef(null);
    const { tableData } = tariffNatureState;
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        tariffNatureVM.updateSelectedRows(selectedRows);
    }, [tariffNatureVM])

    const handleAddClick = useCallback(() => {
        tariffNatureVM.onAdd();
    }, [tariffNatureVM])

    const handleRowDoubleClick = useCallback((entity: TariffNatureEntity) => {
        tariffNatureVM.onEdit(entity);
    }, [tariffNatureVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='tariff-nature-table'
                headerLabel={TariffNatureMaintenanceConstant.TITLE}
                isNewColumnSetting={true}
                columns={INITIAL_TARIFF_NATURE_COL_DEF}
                data={tableData ?? []}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAddClick}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: TariffNatureEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [allowCreate, tableData, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(TariffNatureTablePanel);
